import React, { Fragment } from "react";
import { DataGridView, Row, Col } from "@neumetric/blueprint-lib/components";
import Guide from "./Guide.json";

const MAX = 5;
const MATRIX_COLORS = [
  "#B7F7A6", // 0 - green
  "#D6F5A3", // 1
  "#F7F3A6", // 2
  "#F5C18A", // 3
  "#E67C5C", // 4
  "#C62828", // 5 - red
];
const Columns = [
  {
    dataIndex: "rating",
    title: "Rating",
    typeRepresentation: "CUSTOM",
    width: "10%",
    filterFlag: true,
    sortableFlag: true,
    cellRender: (record) => {
      return (
        <Row align="center">
          <Col
            className="nm-dot-icon mr-8"
            style={{ backgroundColor: record.ratingColor }}
          ></Col>
          <span className="ff-exo2 fw-500 fs-15 line-22 text-filled">
            {record.rating}
          </span>
        </Row>
      );
    },
  },
  {
    dataIndex: "score",
    title: "Score",
    typeRepresentation: "TEXT",
    width: "9%",
  },
  {
    dataIndex: "probabilityRange",
    title: "Probability Range",
    typeRepresentation: "TEXT",
    width: "15%",
  },
  {
    dataIndex: "description",
    title: "Description",
    typeRepresentation: "TEXT",
    width: "36%",
  },
  {
    dataIndex: "examples",
    title: "Real-world Example",
    typeRepresentation: "HTML",
    width: "35%",
  },
];

const Header = ({ title }) => {
  return (
    <Col className="w-100 mb-10 stats-table-guild-header">
      <span className="ff-exo2 fw-500 fs-15 line-22 text-filled">{title}</span>
    </Col>
  );
};

export const StatsGuideInfo = () => {
  const getDataSource = () => {
    return Guide.map((item) => {
      const newItem = { ...item };
      newItem.examples = `<span>${newItem.examples.join("<br/>...")}</span>`;
      return newItem;
    });
  };
  return (
    <Col className="h-1000-px w-73">
      <Header title="Probability of…" />
      <DataGridView columns={Columns} dataSource={getDataSource()} />
    </Col>
  );
};

const Scale = ({ className, reverse = false }) => {
  return (
    <Fragment>
      {[...Array(MAX + 1)].map((_, index) => {
        const value = reverse ? index : MAX - index;
        return (
          <Col
            key={index}
            className={className}
            align="center"
            justify="center"
            style={{
              backgroundColor: MATRIX_COLORS[value],
            }}
          >
            <span className="ff-exo2 fw-500 fs-15 line-22 text-filled">
              {value}
            </span>
          </Col>
        );
      })}
    </Fragment>
  );
};

export default function RiskMatrix() {
  const metrix = (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${MAX + 1}, 50px)`,
      }}
    >
      {[...Array(MAX + 1)].map((_, rowIndex) => {
        const probability = MAX - rowIndex; // 👈 FIX: reverse Y-axis

        return [...Array(MAX + 1)].map((_, impact) => {
          const value = probability * impact;

          const colorIndex = Math.min(Math.round(value / MAX), MAX);

          return (
            <Col
              key={`${probability}-${impact}`}
              className="w-50-px h-50-px"
              align="center"
              justify="center"
              style={{
                backgroundColor: MATRIX_COLORS[colorIndex],
              }}
            >
              <span className="ff-exo2 fw-500 fs-15 line-22 text-filled">
                {value}
              </span>
            </Col>
          );
        });
      })}
    </div>
  );
  return (
    <Col className="ml-16 stats-guide-matrix" align="end">
      <Row>
        <Col className="axis h-300-px w-43-px" align="center" justify="center">
          <span className="ff-exo2 fw-500 fs-15 line-22 text-contrast">
            Event Probability
          </span>
        </Col>
        <Col className="">
          <Scale className="w-25-px h-50-px" />
        </Col>
        {metrix}
      </Row>
      <Row align="start" justify="end">
        <Scale className="w-50-px h-25-px" reverse={true} />
      </Row>
      <Col className="axis w-325-px h-43-px" align="center" justify="center">
        <span className="ff-exo2 fw-500 fs-15 line-22 text-contrast">
          Event Impact
        </span>
      </Col>
    </Col>
  );
}

export const StatsGuideMatrix = () => {
  return (
    <Col className="w-23 stats-guide-matrix-col">
      <Header title="Risk Matrix" />

      {/* NEW wrapper for scaling */}
      <div className="stats-guide-matrix-scale">
        <RiskMatrix />
      </div>
    </Col>
  );
};

export const StatsGuide = () => {
  return (
    <Row
      className="w-100 pl-20 pr-20 stats-guide-row"
      align="start"
      justify="between"
    >
      <StatsGuideInfo />
      <StatsGuideMatrix />
    </Row>
  );
};
